export default {
  help: {
    id: 'header_to_help',
    defaultMessage: 'Help',
  },
  userNavigationAriaLabel: {
    id: 'header_user_navigation_aria_label',
    defaultMessage: 'User navigation',
  },
}
